// Error class with ui message that can be rendered in the UI
export class AppError extends Error {
  constructor(uiMessage = null) {
    super(uiMessage || 'An unexpected error occurred');
    this.uiMessage = uiMessage;
  }
}
